import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
ChartJS.register(ArcElement, Tooltip)

const PayrollOverviewChart = ({ data }) => {

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  }

  return (
    <>
      {data ? (
        <div className='flex w-full h-full flex-col justify-end items-center '>
          <div className='w-[100%] h-[70%] relative mt-3'>
            {data.data && <Doughnut data={data.data} options={chartOptions} />}
            <div className='absolute w-full top-[57%] left-0 text-center -mt-[20px] md:-mt-6 line'>
              <span className='text-[14px] font-extrabold'>{data.total}</span>
            </div>
          </div>
          <div className='grid grid-cols-2 w-full justify-end mt-3 !h-[20%] pb-2 content-around '>
            {data.legends.map((item, index) => (
              <div
                key={index}
                className='flex flex-row items-center px-1 py-1 md:py-0 '
              >
                <div
                  className={`w-[12px] h-[12px] rounded-[12px] ${item.color}`}
                ></div>
                <span className='pl-1 text-[12px]'> {item.title}</span>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  )
}

export default PayrollOverviewChart
